import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface Slide {
  image: string;
  tag: string;
  title: string;
  subtitle: string;
  ctaLabel: string;
  ctaTo: string;
}

const slides: Slide[] = [
  {
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20modern%20Chinese%20city%20skyline%20at%20dusk%20with%20warm%20glowing%20windows%20and%20soft%20mist%2C%20deep%20navy%20blue%20tones%20with%20warm%20orange%20highlights%2C%20moody%20atmospheric%2C%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=hero-main-01&orientation=landscape',
    tag: '本剧热播',
    title: '善良的小姨子',
    subtitle: '一个关于亲情、成长与善意的都市家庭故事，正在温暖上演。',
    ctaLabel: '查看全部剧情',
    ctaTo: '/category/plot',
  },
  {
    image:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20dinner%20table%20scene%20at%20evening%20with%20home%20cooked%20dishes%20and%20steaming%20soup%2C%20soft%20amber%20lamp%20light%2C%20cozy%20domestic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=hero-main-02&orientation=landscape',
    tag: '温暖家庭',
    title: '饭桌上的温度',
    subtitle: '平凡小事里藏着最深的牵挂，每一集都值得慢慢品味。',
    ctaLabel: '从第一集开始',
    ctaTo: '/play/1',
  },
  {
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20young%20woman%20standing%20on%20a%20balcony%20overlooking%20city%20lights%20at%20blue%20hour%2C%20soft%20wind%2C%20warm%20window%20glow%20behind%2C%20hopeful%20mood%2C%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=hero-main-03&orientation=landscape',
    tag: '追剧推荐',
    title: '善良从不被辜负',
    subtitle: '在陌生的城市里，善意像涟漪一样一圈圈荡开。',
    ctaLabel: '进入推荐专题',
    ctaTo: '/special/recommend',
  },
];

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
    }, 5200);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setCurrent((c) => (c + dir + slides.length) % slides.length);
  };

  return (
    <section className="relative w-full h-[440px] md:h-[600px] overflow-hidden bg-primary-950">
      {slides.map((slide, i) => (
        <div
          key={slide.image}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} - 善良的小姨子剧集海报`}
            title={`${slide.title} - 善良的小姨子`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-950/55 to-primary-950/25"></div>
        </div>
      ))}

      <div className="relative z-10 h-full w-full px-4 md:px-10 lg:px-16 flex items-center">
        <div className="w-full max-w-2xl animate-slide-fade" key={current}>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500 text-primary-950 text-xs md:text-sm font-medium mb-4 md:mb-5">
            <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
            {slides[current].tag}
          </span>
          <h1 className="font-heading font-bold text-background-50 text-3xl md:text-5xl lg:text-6xl leading-tight mb-3 md:mb-4">
            {slides[current].title}
          </h1>
          <p className="text-background-200 text-sm md:text-lg leading-relaxed mb-6 md:mb-8 max-w-xl">
            {slides[current].subtitle}
          </p>
          <div className="flex flex-wrap items-center gap-3 md:gap-4">
            <Link
              to={slides[current].ctaTo}
              className="inline-flex items-center gap-2 px-5 md:px-6 py-2.5 md:py-3 rounded-md bg-accent-500 text-primary-950 text-sm md:text-base font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              {slides[current].ctaLabel}
              <i className="ri-play-circle-line w-5 h-5 flex items-center justify-center"></i>
            </Link>
            <Link
              to="/category/cast"
              className="inline-flex items-center gap-2 px-5 md:px-6 py-2.5 md:py-3 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/20 transition-colors whitespace-nowrap backdrop-blur-sm cursor-pointer"
            >
              <i className="ri-team-line w-5 h-5 flex items-center justify-center"></i>
              演员阵容
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(-1)}
        className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 items-center justify-center hover:bg-background-50/25 transition-colors backdrop-blur-sm cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(1)}
        className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 items-center justify-center hover:bg-background-50/25 transition-colors backdrop-blur-sm cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-5 md:bottom-8 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2.5">
        {slides.map((slide, i) => (
          <button
            key={slide.image}
            type="button"
            aria-label={`切换到第 ${i + 1} 张`}
            onClick={() => setCurrent(i)}
            className={`rounded-full transition-all cursor-pointer ${
              i === current ? 'w-8 h-2.5 bg-accent-500' : 'w-2.5 h-2.5 bg-background-50/50 hover:bg-background-50/80'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}